<ng-container>
  <div class="full-width flex justify-between p-3 bg-gray-400 items-center">
    <div>
      <app-main-button (click)="saveAndNavigateBack()">Zurück</app-main-button>
    </div>
    <div>
      <app-main-button
        type="secondary"
        [disabled]="isSaving"
        (click)="saveClothing()"
        >{{ isSaving ? 'Speichern...' : 'Speichern' }}</app-main-button
      >
    </div>
  </div>
</ng-container>

<div class="p-6 bg-white">
  <ng-container>
    <div class="flex justify-between w-full pb-20">
      <div class="text-3xl text-blue-900">Kleiderinformationen</div>
    </div>

    <ng-container>
      <form [formGroup]="validateClothingForm">
        <div class="pb-5 grid grid-cols-12 grid-rows-3 gap-5">
          <app-form-select
            label="Kleidungsart"
            attribute="kleidungsart"
            [selectOptions]="selectClothingType"
            valueKey="codenr"
            labelKey="text"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-select>
          <app-form-select
            label="Größe"
            attribute="kleidergroesse"
            [selectOptions]="selectSizes"
            valueKey="codenr"
            labelKey="text"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Geschlecht"
            attribute="geschlecht"
            [selectOptions]="selectGender"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Firma"
            attribute="firmaId"
            [selectOptions]="companies"
            valueKey="oid"
            labelKey="bezeichnung"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-input
            label="Barcode"
            attribute="inventarnummer"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-input>
        </div>
        <div class="grid grid-cols-12 gap-5">
          <app-form-textarea
            label="Bemerkung"
            attribute="bemerkung"
            subformGroup="optionalFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            placeholder="Schreiben Sie hier einen Kommentar"
          ></app-form-textarea>
        </div>
      </form>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="grid grid-cols-1 space-y-4">
      <p class="flex justify-center text-gray-600">
        Lade Kleiderinformationen...
      </p>
      <nz-spin class="flex justify-center" nzSimple></nz-spin>
    </div>
  </ng-template>
</div>

<nz-modal
  [nzFooter]="duplicateModalFooter"
  [(nzVisible)]="duplicateModalVisible"
  [nzTitle]="duplicateTitle"
  (nzOnCancel)="closeDuplicateModal()"
>
  <ng-container *nzModalContent>
    <div class="flex gap-4">
      <span
        nz-icon
        nzType="exclamation-circle"
        nzTheme="fill"
        class="text-2xl text-orange-500 pt-1"
      ></span>

      <div class="flex-1">
        <p class="text-lg font-medium text-blue-900 pb-1">
          Barcode {{ duplicateBarcode }}
        </p>
        <p class="text-gray-700">{{ duplicateDescription }}</p>

        <div
          *ngIf="duplicateDetails.length"
          class="mt-4 rounded border border-gray-300 bg-gray-100 p-4 grid grid-cols-3 gap-x-4 gap-y-2"
        >
          <ng-container *ngFor="let detail of duplicateDetails">
            <span class="text-gray-600">{{ detail.label }}</span>
            <span class="col-span-2 font-medium text-gray-900">
              {{ detail.value }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #duplicateModalFooter>
  <div class="flex justify-end gap-3 p-3">
    <app-main-button *ngIf="duplicateClothing" (click)="openDuplicateClothing()"
      >Vorhandenes Kleidungsstück öffnen
    </app-main-button>
    <app-main-button type="danger" (click)="closeDuplicateModal()"
      >{{ duplicateClothing ? 'Abbrechen' : 'Verstanden' }}
    </app-main-button>
  </div>
</ng-template>
